
import React from 'react';
import { AlertTriangle, TrendingUp } from "lucide-react";
import { formatCurrency } from "../utils/costAnalysisUtils";

interface RiskFactorsSectionProps {
  riskFactors: string[];
  totalCost: number;
}

const RiskFactorsSection = ({ riskFactors, totalCost }: RiskFactorsSectionProps) => {
  if (!riskFactors || riskFactors.length === 0) return null;

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-white font-bold text-lg">Risk Factors & Considerations</h3>
      </div>
      <div className="p-5 rounded-xl border border-primary">
        <div className="space-y-3">
          {riskFactors.map((risk, index) => (
            <div key={index} className="flex items-start gap-3 p-3 rounded-lg border border-primary-light">
              <p className="text-gray-300 text-sm leading-relaxed">{risk}</p>
            </div>
          ))}
        </div>
        <div className="mt-4 p-3 bg-primary/10 rounded-lg border border-primary/20">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-white font-semibold text-sm">Recommended Buffer:</span>
          </div>
          <p className="text-gray-300 text-sm">
            Consider adding 10-15% contingency ({formatCurrency(totalCost * 0.1)} - {formatCurrency(totalCost * 0.15)}) 
            to account for potential risks and scope changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RiskFactorsSection;
